import React, { useState } from 'react'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'

export default function Counter(props) {

    const [counterOn, setCounterOn] = useState(false)

    const stats = [
        {
            img: 'project_logo.png',
            label: 'Projects Completed',
            value: 19
        },
        {
            img: 'working_logo.png',
            label: 'Working Hours',
            value: 690
        },
        {
            img: 'Client_logo.png',
            label: 'Happy Clients',
            value: 19
        },
        {
            img: 'visitor_logo.png',
            label: 'Profile Visitors',
            value: 3751
        }
    ]

    return (
        <ScrollTrigger
            onEnter={() => setCounterOn(true)}
            onExit={() => setCounterOn(false)}
        >

            <div
                className={`container user-select-none text-center fs-5 mb-5 py-4
        ${props.isDesktop ? 'border rounded-4' : ''}
        ${props.mode === 'dark' ? 'bg-dark text-light' : ''}`}
                style={
                    props.mode !== 'dark'
                        ? { background: 'linear-gradient(45deg, #ffe555, #00bcd4)' }
                        : {}
                }
            >

                <div className="row row-cols-2 row-cols-md-4 g-4">

                    {stats.map((item, index) => (
                        <div className="col" key={index}>

                            <img
                                src={item.img}
                                alt={item.label}
                                className="mb-2"
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    objectFit: 'contain'
                                }}
                            />

                            <p className="fw-bold mb-0">
                                {item.label}
                                <br />

                                <span className="fs-4">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={item.value}
                                            duration={3}
                                            delay={0}
                                        />
                                    )}
                                    +
                                </span>
                            </p>

                        </div>
                    ))}

                </div>

            </div>

        </ScrollTrigger>
    )
}